import React from 'react';
import styled from 'styled-components';

import theme from 'styles/theme';

const Skill = styled.div`
  display: flex;
  flex-flow: column;

  .Skill__title {
    background: ${theme.B400};
    color: ${theme.font_primary};
    text-transform: uppercase;
    text-align: center;
    padding: 10px 25px;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
  }

  .Skill__content {
    padding: ${props => (props.compact !== undefined ? '15px 5px' : '30px 5px')};

    @media screen and (max-width: 600px) {
      padding: ${props => (props.compact !== undefined ? '25px 5px' : '15px 5px')};
    }
  }
`;

export default props => (
  <Skill compact={props.compact}>
    <div className="Skill__title">{props.header}</div>
    <div className="Skill__content">{props.children}</div>
  </Skill>
);



// WEBPACK FOOTER //
// ./src/components/Skill/Skill.js